import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Paper, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SchoolIcon from "@mui/icons-material/School";

function EducationalQualification() {
  const location = useLocation();
  const isPublicResultRoute = location.pathname.includes("/public-result");

  // Get data from appropriate reducer based on route
  const publicResult = useSelector(
    (state) => state?.ResultReducer?.publicResult || {}
  );
  const oldFormReducer = useSelector(
    (state) => state?.OldFormReducer || {}
  );

  // Determine which data source to use
  const resultData = isPublicResultRoute
    ? publicResult?.userData || publicResult || {}
    : oldFormReducer;

  const [userData, setUserData] = useState({
    education: [],
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    // Get education from the appropriate source
    const educationData = isPublicResultRoute
      ? publicResult?.userData?.education || publicResult?.education || []
      : resultData?.education || [];

    if (Array.isArray(educationData) && educationData.length > 0) {
      setUserData({
        education: educationData,
      });
    } else {
      setUserData({
        education: [],
      });
    }
    setLoading(false);
  }, [resultData, publicResult, isPublicResultRoute]);

  // Only render if there's education data
  if (!Array.isArray(userData?.education) || userData.education.length === 0) {
    return null;
  }

  return (
      <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
        <Grid item xs={12}>
          {userData?.education && userData.education.length > 0 && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  border: "1px solid #8DE49A",
                  borderRadius: "20px",
                  p: { xs: 3, sm: 3, md: 3, lg: 3 },
                  minWidth: { xs: "100%", md: "100%", lg: "70%" },
                  maxWidth: {
                    xs: "100%",
                    md: "100%",
                    lg: userData?.education !== "" ? "100%" : "70%",
                  },
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      mb: "32px",
                    }}
                  >
                    <div
                      style={{
                        width: "51px",
                        height: "51px",
                        backgroundColor: "#2bb344",
                        color: "#ffffff",
                        borderRadius: "30%",
                      }}
                    >
                      <SchoolIcon
                        sx={{
                          width: { xs: "40px", md: "100%" },
                          height: "40px",
                          maxWidth: "51px",
                          alignSelf: "center",
                          marginTop: "5px",
                        }}
                        alt="SchoolIcon"
                      />
                    </div>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 600,
                        pl: { xs: 1, lg: 2 },
                        textAlign: "center",
                      }}
                    >
                      Educational Qualification
                    </Typography>
                  </Box>

                  {loading ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        py: 2,
                      }}
                    >
                      <CircularProgress color="primary" size={30} />
                    </Box>
                  ) : (
                    <Grid
                      container
                      sx={{
                        gap: 2,
                        justifyContent: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {userData?.education?.map((edu, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={12}
                          lg={12}
                          xl={12}
                          key={index}
                        >
                          <Paper
                            sx={{
                              border: "1px solid #8DE49A",
                              borderRadius: "15px",
                              display: "flex",
                              flexDirection: "column",
                              boxShadow: "none",
                              alignItems: "center",
                              p: 2,
                              maxWidth: "500px",
                            }}
                          >
                            {edu.institution && (
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "16px",
                                    md: "20px",
                                    lg: "20px",
                                  },
                                  fontWeight: 300,
                                }}
                              >
                                <b>Institution :</b>
                                {edu.institution}
                              </Typography>
                            )}
                            {edu.type && (
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "16px",
                                    md: "20px",
                                    lg: "20px",
                                  },
                                  fontWeight: 300,
                                }}
                              >
                                <strong>Type : </strong>
                                {edu.type}
                              </Typography>
                            )}
                            {edu.fieldOfStudy && (
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "16px",
                                    md: "20px",
                                    lg: "20px",
                                  },
                                  fontWeight: 300,
                                }}
                              >
                                <strong>Field of Study : </strong>
                                {edu.fieldOfStudy}
                              </Typography>
                            )}
                            {edu.location && (
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "16px",
                                    md: "20px",
                                    lg: "20px",
                                  },
                                  fontWeight: 300,
                                }}
                              >
                                <strong>Location : </strong>
                                {edu.location}
                              </Typography>
                            )}
                            {edu.duration && (
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "16px",
                                    md: "20px",
                                    lg: "20px",
                                  },
                                  fontWeight: 300,
                                }}
                              >
                                <strong>Duration : </strong>
                                {edu.duration}
                              </Typography>
                            )}
                            {edu.percentageOrGPA && (
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "16px",
                                    md: "20px",
                                    lg: "20px",
                                  },
                                  fontWeight: 300,
                                }}
                              >
                                <strong>Percentage/GPA : </strong>
                                {edu.percentageOrGPA}
                              </Typography>
                            )}
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Box>
          )}
        </Grid>
      </Box>
  );
}

export default EducationalQualification;
